import React, { Component } from 'react';
import { connect } from 'react-redux';

import { ABORTED_REQUEST_ERROR } from '@vestahealthcare/common/utils/constants';

import {
  broadcastError,
  broadcastWarning,
  closeGlobalMessage,
  getMessagePayload,
} from 'dash/src/redux/actions/GlobalActions';
import store from 'dash/src/redux/store';

import Message from './Message';

const mapStateToProps = (state: any) => ({
  messagePayload: getMessagePayload(state),
});

const dispatchers = (dispatch: any) => ({
  clearAndClose: () => dispatch(closeGlobalMessage()),
});

interface Props {
  messagePayload: any;
  clearAndClose: () => void;
}

class GlobalMessages extends Component<Props> {
  getProps(payload: any) {
    let props;

    if (typeof payload === 'string') {
      // Single string
      props = { messages: [{ message: payload }] };
    } else if (payload && payload.isResponseError) {
      // Build the message with the response error
      props = {
        ...payload,
        title: payload.message,
        messages:
          payload.allErrors && payload.allErrors.length
            ? payload.allErrors
            : undefined,
      };
    } else if (payload && typeof payload.message === 'string') {
      // The legacy way: If it's an error and we pass a single `message` convert it
      // to the right structure. Also handles Error instances
      props = {
        ...payload,
        messages: [{ message: payload.message, detail: payload.detail }],
      };
    } else {
      // Assumed we got the expected structure, or just nothing:
      // { messages: [{ message, detail }] }
      props = payload || {};
    }

    return props;
  }

  render() {
    const { messagePayload, clearAndClose } = this.props;

    return (
      <>
        <Message
          open={messagePayload.isOpen}
          {...this.getProps(messagePayload)}
          onDismiss={() => clearAndClose()}
        />
      </>
    );
  }
}

type ErrorType = {
  errors: {
    message: string;
  }[];
};

export const showGlobalError = (error: string | ErrorType) => {
  if (
    typeof error !== 'string' &&
    error?.errors &&
    error?.errors instanceof Array &&
    error?.errors?.find((e) => e?.message === ABORTED_REQUEST_ERROR)
  )
    return;
  return store.dispatch(broadcastError(error));
};

export const showGlobalWarning = (warning: string | object) =>
  store.dispatch(broadcastWarning(warning));

export default connect(mapStateToProps, dispatchers)(GlobalMessages);
